var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-item",class:{ 'is-active': _vm.isActive ? _vm.isActive() : null },attrs:{"disabled":_vm.disabled,"title":_vm.title},on:{"click":_vm.action}},[_c('v-icon',{staticClass:"thin"},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }